import { store } from '@app/helpers/store';

export const setupIntercom = (window: any) => {
    const shellConfig: any = store.getState().basic.shellConfig;

    // Intercom shows if - Shell has values, not already rendered, and only default org
    if (window.Intercom && shellConfig.intercom?.isDefaultOrg) {
        window.Intercom('update', { 'hide_default_launcher': false });
        return;
    }

    if (!window.intercomSettings && shellConfig.intercom && shellConfig.intercom.isDefaultOrg) {
        window.intercomSettings =
        {
            app_id: shellConfig.intercom.appId,
            name: shellConfig.intercom.name,
            user_id: shellConfig.intercom.userId,
            alignment: 'left',
            horizontal_padding: 200,
            vertical_padding: 20,
            "Product": shellConfig.intercom.product,
            "ReleaseNumber": shellConfig.aaVersion,
            "ProductOwner": shellConfig.intercom.productOwner,
            "IsTrial": shellConfig.intercom.isTrial,
            "IsAdmin": shellConfig.intercom.isAdmin,
            "SFID": shellConfig.intercom.salesforceId,
            "org": shellConfig.intercom.tenantName,
            "region": shellConfig.intercom.region,
            "ServerName": shellConfig.intercom.serverName
        };

        (function () {
            var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', window.intercomSettings); }
            else {
                var d = document; var i: any = function () { i.c(arguments) }
                    ; i.q = []; i.c = function (args: any) { i.q.push(args) }
                    ; w.Intercom = i; function l() { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + shellConfig.intercom.appId; var x = d.getElementsByTagName('script')[0]; x.parentNode?.insertBefore(s, x); }
                l()
            }
        })();
    }
};

export const hideIntercom = (window: any) => {
    if (window.Intercom) {
        window.Intercom('update', { 'hide_default_launcher': true });
    }
};

export const shutdownIntercom = (window: any) => {
    if (window.Intercom) {
        window.Intercom('shutdown');
    }
};